import * as React from 'react'
import classNames from 'classnames'
import './skeleton.scss'

interface SkeletonBarProps {
    width?: string
    height?: string
    className?: string
}

export function SkeletonBar({ width = '100%', height = '0.625rem', className }: SkeletonBarProps) {
    return <span className={classNames('skeleton-bar', className)} style={{ width, height }} aria-hidden="true" />
}
